import { IFlag } from './types';

export const formatFlagName = (name: string): string => {
  return name
    .split('_')
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(' ');
};

export const sortFlagsByBlocking = (flags: IFlag[]): IFlag[] => {
  return [...flags].sort((a, b) => {
    if (a.category === 'BLOCKING' && b.category !== 'BLOCKING') {
      return -1;
    }
    if (a.category !== 'BLOCKING' && b.category === 'BLOCKING') {
      return 1;
    }

    return 0;
  });
};
